import { ColDef } from 'ag-grid-community';

export const NotesColumnDef: ColDef[] = [
  {
    // Row Index
    headerName: '#',
    valueGetter: 'node.rowIndex + 1',
    maxWidth: 50,
    width: 50,
    flex: 2
  },
  {
    // Note Type
    headerName: 'Note Type',
    field: 'note_type',
    resizable: true,
    width: 150,
  },
  {
    // Comment
    headerName: 'Comment',
    field: 'comment',
    resizable: true,
    width: 125,
    flex: 1,
  },
  {
    // Username
    headerName: 'Username',
    field: 'username',
    resizable: true,
    width: 125,
  },
  {
    // Date Time
  headerName: 'Date Time',
  field: 'dateTime', // or 'date_time_stamp'
  resizable: true,
  valueFormatter: params => {
    if (!params.value) return '';
    const date = new Date(params.value);
    return date.toLocaleString('en-US', {
      hour12: true,
      year: 'numeric',
      month: 'short',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    });
  }
}
];
export const EventLogsColumnDef: ColDef[] = [
  {
    // Row Index
    headerName: '#',
    valueGetter: 'node.rowIndex + 1',
    width: 50,
  },
  {
    // Event
    headerName: 'Event',
    field: 'event',
    resizable: true,
    width: 160,
  },
  {
    // Was
    headerName: 'Was',
    field: 'value_changed_from',
    resizable: true,
    width: 200,
    tooltipField: 'value_changed_from',
    valueFormatter: params => params.value == null || params.value == 'null' ? '-' : params.value
  },
  {
    // Updated To
    headerName: 'Updated To',
    field: 'value_changed_to',
    resizable: true,
    width: 200,
    tooltipField: 'value_changed_to',
    valueFormatter: params => params.value == null || params.value == 'null' ? '-' : params.value
  },
  {
    // Date Time
    headerName: 'Date Time',
    field: 'date_time_stamp',
    resizable: true,
    valueFormatter: params => {
    if (!params.value) return '';
    const date = new Date(params.value);
    return date.toLocaleString('en-US', {
      hour12: true,
      year: 'numeric',
      month: 'short',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    });
  }
  },
  {
    // Username
    headerName: 'Username',
    field: 'username',
    resizable: true,
  },
];
